import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IRegistrationConfirmFields,
} from '../types';
import {
  REGISTER_CONFIRMATION_MUTATION_KEY,
  REGISTER_CONFIRMATION_URL,
  REGISTRATION_PERMISSIONS,
} from '../constants';

export default function useRegisterConfirmationMutation(): IContextMutationResult<void, Error, IRegistrationConfirmFields> {
  const { fetchGet } = useRestClient();

  return useContextMutation<void, Error, IRegistrationConfirmFields>({
    mutationKey: [REGISTER_CONFIRMATION_MUTATION_KEY],
    mutationFn: (queryParams) => fetchGet<void>(REGISTER_CONFIRMATION_URL, {
      permission: REGISTRATION_PERMISSIONS.REGISTER,
      queryParams,
    }),
  });
}
